/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {UserGroupContainUserComponent as ɵf} from './user-group-contain-user/user-group-contain-user.component';
export {UserPermissionAreaComponent as ɵc} from './user-permission-area/user-permission-area.component';
export {UserPermissionFilterComponent as ɵd} from './user-permission-filter/user-permission-filter.component';
export {UserRoleComponent as ɵe} from './user-role/user-role.component';
export {UserPermissionComponent as ɵb} from './userpermission.component';
export {declaration as ɵa} from './userpermission.module';
export {UserPermissionRoutes as ɵg} from './userpermission.routing';